export function LocationViewModel(data) {
  this.Id = data.id;
  this.SubscriptionId = data.subscriptionId;
  this.DisplayName = data.displayName;
  this.Name = data.name;
}
